import { InfoFilledIcon, RightOutlineIcon } from 'components/common/SVGIcon';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { setCentreId } from 'redux/auth/slice';
import { useDispatch } from 'react-redux';
import { ExceededInfoStyles } from './styles';

const ExceededInfo = ({ centreId }) => {
  const { push } = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const goToSubscriptions = useCallback(() => {
    push('/subscriptions');
    centreId && dispatch(setCentreId(centreId));
  }, [push, centreId, dispatch]);

  return (
    <ExceededInfoStyles className="rounded-12 mt-12">
      <div className="flex">
        <InfoFilledIcon className="text-20 text-blue-info-default" />
        <span className="ml-8 text-14 text-black-base lh-24">
          {t('enquiries.exceededEnquiriesDes')}
        </span>
      </div>
      <div
        onClick={goToSubscriptions}
        className="flex-center-end mt-8 text-primary fw-bold cursor-pointer"
        role="presentation"
      >
        <span className="text-12">{t('button.goToSubscriptions')}</span>
        <RightOutlineIcon className="ml-4 text-16" />
      </div>
    </ExceededInfoStyles>
  );
};
export default ExceededInfo;
